export enum RelationshipDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}
